export default {
  name: 'THC',
  isRotated: true,
  versions: [
    'thc/thc_1.jpg',
  ],
  containerStyle: {
    paddingBottom: '20%',
    paddingLeft: '45%',
    paddingRight: '5%'
  },
  baseStyle: {
    fontFamily: '"Destroy Earth", sans-serif',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    textAlign: 'left',
    display: 'inline-block',
    position: 'relative',
    lineHeight: '0.8',
    marginTop: '5px',
    marginBottom: '5px'
  },
  customStyles: [
    {
      name: "blau",
      style: {
        color: '#143352',
      }
    },
    {
      name: "rote box",
      style: {
        color: '#FFFFFF',
        backgroundColor: '#DC0D1B',
        padding: '12px 12px 8px 12px'
      }
    },
  ],
  linesDefault: [
    {
      text: 'Tigern Sie zum Loewen!',
      style: 0,
      fontSize: 70
    },
    {
      text: 'Brille: Fielmann.',
      style: 1,
      fontSize: 30
    }]
}



// WEBPACK FOOTER //
// ./src/config/thc.js